export const RSVP_BLOCK_TYPE = 'rsvp';
export const FORM_BLOCK_TYPE = 'form';
export const FORM_DROP_PANEL_TYPE = 'form_droppanel';
export const SECTION_BLOCK_TYPE = 'section';
export const SECTION_DROP_PANEL_TYPE = 'section_droppanel';

/**@deprecated we keep this block around so older forms using it do not break, it is no longer possible to add this block to a form */
export const RSVP_YES_BLOCK_TYPE = 'rsvpyes';
/**@deprecated we keep this block around so older forms using it do not break, it is no longer possible to add this block to a form */
export const RSVP_NO_BLOCK_TYPE = 'rsvpno';
export const ACCOUNT_BLOCK_TYPE = 'account';
export const PAYMENT_BLOCK_ANSWER_TYPE = 'Card Payment';
export const TICKET_BLOCK_TYPE = 'ticket';
export const TRANSACTION_BLOCK_TYPE = 'transaction';
export const SUBSCRIPTION_ANSWER_TYPE = 'Subscription';
export const FORM_VALIDATION_ERROR_NAME = 'Form';
export const SUBSCRIPTION_BLOCK_TYPE = 'subscription-question';
export const URL_REDIRECT_BLOCK_TYPE = 'url-redirect';
export const EVENT_LOCATION_MAP_BLOCK_TYPE = 'event-location';
export const DROP_PANEL_BLOCK_TYPE = 'droppanel';
export const POINTS_BLOCK_TYPE = 'points';
export const SURVEY_BUTTON_NEXT_BLOCK_TYPE = 'survey-button-next';
export const SURVEY_BUTTON_PREVIOUS_BLOCK_TYPE = 'survey-button-previous';
export const SURVEY_BUTTON_SUBMIT_BLOCK_TYPE = 'survey-button-submit';
export const UPLOAD_FILES_BLOCK_TYPE = 'upload-files-question';
export const QUESTION_BLOCK_TYPE = 'question';
export const CREATE_PEOPLE_BLOCK = 'CreatePeople';
export const CREATE_PERSON_BLOCK = 'CreatePerson';
